/* NEX quick add: small bag icon on cards; when a colour / size is needed it opens a steady bottom sheet (nothing moves behind your finger) */
(function () {
  'use strict';
  var H = {
    esc: function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; },
    img: function (u, w) { if (!u) return ''; u = typeof u === 'string' ? u : (u.src || u.url || ''); return u ? u.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; },
    money: function (c) { return 'EGP ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  };
  var css = [
    'html body .qa{position:fixed!important;top:0!important;left:0!important;right:auto!important;bottom:auto!important;width:100vw!important;height:100vh!important;height:100dvh!important;margin:0!important;padding:0!important;border-radius:0!important;overflow:hidden!important;z-index:2147483000;display:flex!important;align-items:flex-end;justify-content:center;background:rgba(10,4,26,.6);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);animation:qa-bg .2s ease}',
    '.qa .qa__box{position:relative;width:100%;max-width:480px;max-height:86vh;overflow:auto;padding:18px 18px calc(22px + env(safe-area-inset-bottom,0px));border-radius:24px 24px 0 0;background:#20094a;color:#fff;box-shadow:0 -20px 50px rgba(0,0,0,.4);animation:qa-up .28s cubic-bezier(.2,.9,.25,1)}',
    '.qa__top{display:flex;gap:14px;align-items:center;margin:0 34px 14px 0}',
    '.qa .qa__img{flex:none!important;width:62px!important;height:78px!important;aspect-ratio:auto!important;border-radius:12px;overflow:hidden;background:#fff;display:block!important}',
    '.qa .qa__img img{width:100%;height:100%;object-fit:cover}',
    '.qa__t{display:block;font:700 16px/1.25 Fredoka,system-ui,sans-serif}',
    '.qa__p{display:block;margin-top:4px;font:700 15px/1 Fredoka,system-ui,sans-serif;color:#c8ff3d}',
    '.qa__p s{margin-left:8px;color:#fff;opacity:.5;font-weight:500}',
    '.qa .rc__opt{position:static!important;inset:auto!important;width:auto!important;max-width:none!important;height:auto!important;min-height:0!important;max-height:none!important;transform:none!important;padding:0!important;margin:0!important;background:none!important;border:0!important;box-shadow:none!important;overflow:visible!important;display:flex!important;flex-direction:column;gap:8px}',
    '.qa .rc__opt[hidden]{display:none!important}',
    '.qa .ro__x{position:absolute!important;top:12px!important;right:12px!important;left:auto!important;width:32px!important;height:32px!important;border-radius:50%;border:0;background:rgba(255,255,255,.14);color:#fff;font-size:20px;line-height:1;cursor:pointer}',
    '.qa .ro__go{width:100%!important;height:44px!important;margin-top:12px!important}',
    '@keyframes qa-bg{from{opacity:0}}',
    '@keyframes qa-up{from{transform:translateY(40px);opacity:0}}',
    'body:has(.qa) .wm__trk{animation-play-state:paused!important}'
  ].join('\n');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function add(id) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { document.dispatchEvent(new CustomEvent('nex:added')); });
  }
  function done(b) {
    var t = b.getAttribute('data-t') || b.textContent; b.setAttribute('data-t', t);
    b.classList.add('is-done'); b.textContent = 'Added';
    setTimeout(function () { b.classList.remove('is-done'); b.textContent = t; b.disabled = false; }, 1800);
  }
  function closeQa() { var o = document.querySelector('.qa'); if (o) o.remove(); }
  function openFor(b) {
    closeQa();
    b.disabled = true;
    fetch('/products/' + b.getAttribute('data-qa') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var av = (p.variants || []).filter(function (v) { return v.available; });
        if (!av.length) { b.textContent = 'Sold out'; return; }
        if (av.length === 1 || !window.NexOpts) { return add(av[0].id).then(function () { done(b); }); }
        var tmp = document.createElement('div'); tmp.innerHTML = NexOpts.card(p, H);
        var opt = tmp.querySelector('.rc__opt');
        if (!opt) { return add(av[0].id).then(function () { done(b); }); }
        opt.hidden = false;
        var cmp = typeof p.compare_at_price === 'number' && p.compare_at_price > p.price ? '<s>' + H.money(p.compare_at_price) + '</s>' : '';
        var src = p.featured_image || (p.images && p.images[0]) || '';
        var q = document.createElement('div'); q.className = 'qa'; q.setAttribute('data-rc', p.id);
        var box = document.createElement('div'); box.className = 'qa__box';
        box.innerHTML = '<div class="qa__top"><span class="rc__img qa__img"><img alt="" src="' + H.esc(H.img(src, 200)) + '"></span><span><b class="qa__t">' + H.esc(p.title) + '</b><span class="qa__p">' + H.money(p.price) + cmp + '</span></span></div>';
        box.appendChild(opt); q.appendChild(box); document.body.appendChild(q);
        b.disabled = false;
        var pc = b.getAttribute('data-color');
        if (pc) [].forEach.call(q.querySelectorAll('.ro__dot'), function (d) { if (d.getAttribute('data-c') === pc) d.click(); });
      })
      .catch(function () { b.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var t = e.target, b = t.closest('[data-qa]');
    if (b) { e.preventDefault(); e.stopPropagation(); if (!b.disabled) openFor(b); return; }
    var q = t.closest('.qa');
    if (!q) return;
    e.preventDefault(); e.stopPropagation();
    if (t === q) { q.remove(); return; }
    if (!window.NexOpts) return;
    NexOpts.click(t, function (id, btn) {
      btn.disabled = true;
      return add(id).then(function () { q.remove(); }).catch(function () { btn.disabled = false; });
    });
    var op = q.querySelector('.rc__opt'); if (op && op.hidden) q.remove();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQa(); });
})();